/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useEffect, useState, useCallback, useContext,
} from 'react';
import moment from 'moment';
import { motion } from 'framer-motion';
import { distributorService } from '../../../service/distributor.service';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import IndentListSkeleton from '../IndentReport/indentlistSkeleton';
import Pagination from '../../../Components/Pagination';
import FilterModal from './FilterModal';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { GenerateDateandTime } from '../../../redux/helper/DateConverter';
import { CamelCase, PriceHandler } from '../../../redux/helper/CamelCase';

function PendingOrderStatementReport() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [pendingOrderReportList, setPendingOrderReportList] = useState([]);
    const [threeplList, setThreeplList] = useState([]);
    const [sortType, setsortType] = useState('created_at+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [Filter, setFilter] = useState({
        order_type: [],
        plant_name: [],
        date_range: [],
        customer_code: [],
    });
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchthreepl = async () => {
        const data = await distributorService.shippingOrganizationLocationsForFilter();
        if (data.data.success_status === true) {
            setThreeplList(data.data.Items);
        }
    };

    const handlePendingOrderReports = useCallback((() => {
        distributorService.MISPendingOrderReport(currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setPendingOrderReportList(response.data.Items);
                setalldata(response.data.Items);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.MISPendingOrderReport(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handlePendingOrderReports();
        handleFetchthreepl();
    }, [handlePendingOrderReports]);

    return (
        <div>
            <div className="py-6 pr-[18px] main-screen">
                <div className="flex justify-between pt-[18px]">
                    <h5 className="text-xs4 font-normal text-[#555259]">Pending Order Statement Report</h5>
                    <div className="flex">
                        <button
                            type="button"
                            className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                            style={{
                                border: '2px solid #E9EDF4',
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#filtermodal"
                            onClick={() => setFilterModal(true)}
                        >
                            Filter
                        </button>
                        {' '}
                        <div className="relative mr-2">
                            <label htmlFor="search" />
                            <input
                                type="text"
                                name="search"
                                id="search"
                                className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[10px]"
                                placeholder="Search"
                                value={searchValue}
                                onChange={(e) => {
                                    setsearchValue(e.target.value);
                                    setCurrentPage(1);
                                }}
                                autoComplete="off"
                            />
                            <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                        </div>
                        <div className="mr-2 dropdown relative" />
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] right-[28px] top-[173px]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <IndentListSkeleton /> : (
                <div>
                    {pendingOrderReportList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="top-0 left-0 sticky z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Area Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Area Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order Type
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[150px]  pt-4">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'ORDER_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'ORDER_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'ORDER_DATE+asc') {
                                                                setsortType('ORDER_DATE+desc');
                                                            } else if (sortType === 'ORDER_DATE+desc') {
                                                                setsortType('ORDER_DATE+asc');
                                                            } else {
                                                                setsortType('ORDER_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Customer Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order Acceptance No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Plant /Warehouse
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[240px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Ordered Item Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Description
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                UOM
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Pending Quantity
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[212px] rounded-br-lg rounded-tr-lg">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                PRD Value
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pendingOrderReportList.length > 0 && pendingOrderReportList.map((item) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4 z-[1]"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.AREA_CODE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.AREA_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                {item?.ORDER_TYPE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ENQUIRY_ID}
                                            </td>
                                            <td className="text-sm font-normal py-2.5 px-7 text-center">
                                                {item?.ORDER_DATE !== null ? moment(item?.ORDER_DATE).format('DD-MMM-YYYY, HH:mm:ss') : '-'}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CUSTOMER_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CUSTOMER_CODE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ORDER_ACCEPTANCE_NUMBER}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.PLANT_WAREHOUSE}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.ORDERED_ITEM_CODE}
                                            </td>
                                            <td className="text-sm font-normal more-lines text-[#090406] py-1 px-7 text-center">
                                                {item?.DESCRIPTION}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.UOM}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.PENDING_QUANTITY}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item?.PRD_VALUE)}
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && pendingOrderReportList && pendingOrderReportList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {filterModal && (
                        <FilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            selected={selected}
                            setselected={setselected}
                            handleFilter={handleFilter}
                            handlePendingOrderReports={handlePendingOrderReports}
                            threeplList={threeplList}
                            pendingOrderReportList={pendingOrderReportList}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                </div>
            )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="Pending Order Statement Report"
                    buttonRequired={false}
                    all={searchValue.length > 0 ? 'under searched term' : 'found'}
                />
            )}
        </div>
    );
}

export default PendingOrderStatementReport;
